// extracted by mini-css-extract-plugin
export var banner = "_23-0";